import { render, staticRenderFns } from "./ModalSetPassword.vue?vue&type=template&id=11f2b2b0&"
import script from "./ModalSetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports